import TeamApi from '../../../api/src/user/api/TeamApi'
import {message} from "ant-design-vue";

const teamApi = new TeamApi();

const state = {
    majorList: []
}

const mutations = {
    addMajorList(state, data) {
        state.majorList = data || []
    },
}

const actions = {
    // 分页查询课程组
    pageTeam: ({commit, state}, query) => {
        return new Promise((resolve, reject) => {
            teamApi.page(query.pageNum,query.body).then(res=>{
                resolve(res)
            }).catch(err=>{
                message.error(err.message)
                reject(err)
            })
        })
    },
    // 新增课程组
    addTeam: ({commit, state}, query) => {
        return new Promise((resolve, reject) => {
            teamApi.add(query.body).then(res => {
                resolve(res)
            }).catch(err => {
                message.error(err.message)
                console.log(err)
            })
        })
    },
    // 删除课程组
    delTeam: ({commit, state}, id) => {
        return new Promise((resolve, reject) => {
            teamApi.remove(id).then(res => {
                resolve(res)
            }).catch(err => {
                message.error(err.message)
                console.log(err)
            })
        })
    },
    // 修改课程组
    editTeam: ({commit, state}, query) => {
        return new Promise((resolve, reject) => {
            teamApi.edit(query.id, query.body).then(res => {
                resolve(res)
            }).catch(err => {
                message.error(err.message)
            })
        })
    },
    // 获取课程组详情
    detailTeam: ({commit, state}, id) => {
        return new Promise((resolve, reject) => {
            teamApi.detail(id).then(res => {
                resolve(res)
            }).catch(err => {
                message.error(err.message)
            })
        })
    },
    // 课程组课程列表
    teamCourseList: ({commit, state}, query) => {
        return new Promise((resolve, reject) => {
            teamApi.courseList(query.id, query.pageNum).then(res => {
                resolve(res)
            }).catch(err => {
                message.error(err.message)
            })
        })
    },
    // 课程组成员列表
    teamMemberList: ({commit, state}, query) => {
        return new Promise((resolve, reject) => {
            teamApi.memberList(query.teamId, query.pageNum).then(res => {
                resolve(res)
            }).catch(err => {
                message.error(err.message)
            })
        })
    }
}

export default {
    // namespaced: true,
    state,
    actions,
    mutations
}